import { getWindow } from '@vendor/window/window';

/**
 * Checks if a class is present on a DOM element.
 * Jquery equivalent of hasClass
 *
 * @export
 * @param {*} element
 * @param {string} className
 * @returns {boolean}
 */
export function hasClass(element: any, className: string): boolean {
    if (!element || !className) {
        return false;
    }
    return new RegExp('(\\s|^)' + className + '(\\s|$)').test(element.className);
}

/**
 * Returns the offset of the element relative to DOM rather than relative to parent.
 * Jquery equivalent of offset()
 *
 * @export
 * @param {*} element
 * @returns {number}
 */
export function getOffset(element: any): { top, left } {
    if (!element) {
        return null;
    }
    const rect = element.getBoundingClientRect();
    const nativeWindow = getWindow();

    return {
        top: rect.top + nativeWindow.document.body.scrollTop,
        left: rect.left + nativeWindow.document.body.scrollLeft
    };
}

/**
 * Calculates scroll direction and list index
 * @param scroller
 * @param rowHeight
 * @param prevScrollData
 * @returns {{index: number, direction: number}}
 */
export function getIndexFromScroll(scroller: HTMLElement, rowHeight: number = 1, prevScrollData?: any): any {
    let currentIndex: number = 0;
    let bottomIndex: number = 0;
    let scrollDirection: number = 0;
    let scrollTop: number = 0;

    if (scroller) {
        scrollTop = scroller.scrollTop;
        if (prevScrollData) {
            scrollDirection = scrollTop - prevScrollData.scrollTop;
        }
        const scrollIndex = scrollTop / rowHeight;
        // const scrollIncrement = scrollIndex % 1;

        currentIndex = Math.floor(scrollIndex);
        bottomIndex = currentIndex + Math.floor(scroller.clientHeight / rowHeight);
    }

    return { index: currentIndex, direction: scrollDirection, bottomIndex, scrollTop };
}

export function getOffsetTopFromScroller(el: HTMLElement, scrollEl: HTMLElement): number {

    let offsetTop: number = 0;

    while (el != null && el !== scrollEl) {
        offsetTop += el.offsetTop || 0;
        el = <HTMLElement>el.offsetParent;
    }

    return offsetTop;
}
